module.exports = __webpack_public_path__ + "img/file-background.bd321b81.png";